import React, { useState } from 'react';
import './Login.css';
import loginBackground from '../Images/login_background1.png'; // Make sure this path is correct


function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const SECRET_KEY='secretkey123';

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
      window.location.href = '/dashboard';
    } catch (error) {
      console.error('Login error:', error);
      // You might want to show an error message to the user here
    }
  };

  // const verifyLogin = (email, password) => {
  //   fetch('/login/verify', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       email: email,
  //       password: password
  //     })
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     console.log('Success:', data);
  //     localStorage.setItem('token', data.Token);
  //   })
  //   .catch((error) => {
  //     console.error('Error:', error);
  //   });
  // }


  return (
    <div className="login-container" style={{backgroundImage: `url(${loginBackground})`}}>
      <div className="login-form">
        <h1>Log in</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <div className="form-group">
            <a href="#" className="forgot-password">Forgot your password?</a>
          </div>
          <button type="submit" className="login-button">Log in</button>
        </form>
        <div className="signup-link">
          <a href="#">Sign up</a>
        </div>
      </div>
    </div>
  );
}

export default Login;